import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import {
  Grid,
  Divider,
  Button,
  TextField,
  Modal,
  Fade,
  Backdrop,
  Typography,
} from '@material-ui/core'
import { useFormState } from 'hooks/useFormState'
import { useCadaverService } from 'hooks/useCadaverService'
import { useExameNecroscopicoService } from 'hooks/useExameNecroscopicoService'
import { SelectComposto } from '../../../../components/SelectComposto/SelectComposto'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  field: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },

  item: {
    marginBottom: theme.spacing(1),
  },

  inputForm: {
    height: theme.spacing(7),
  },

  divider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },

  botaoAddFiliacao: {
    marginBottom: theme.spacing(2),
  },

  textoConfiguracao: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  corpoFormulario: {
    marginBottom: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  dividerBotton: {
    marginBottom: theme.spacing(2),
  },
  CampoForm: {
    marginBottom: theme.spacing(2),
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

const schema = {
  tipo: {
    presence: { allowEmpty: false, message: '^Tipo do fenômeno é obrigatório' },
  },
}

export const FormAddFenomenoCadaverico = (props) => {
  const {
    idExame,
    idCadaver,
    setFenomenosCadavericos,
    setProcessando,
    processando,
    open,
    setOpen,
  } = props
  const classes = useStyles()
  const cadaverService = useCadaverService()
  const exameNecroscopicoService = useExameNecroscopicoService()
  const formAddFenomeno = useFormState(schema)
  const options = useSelector((state) => state.options)

  useEffect(() => {
    if (!options.tiposFenomenosCadavericos) {
      exameNecroscopicoService.listarTiposFenomenosCadavericosGlobal()
    }
   
  }, [])

  const formError = () => {
    let disable = false
    if (!formAddFenomeno.formState.values.tipo) {
      disable = true
    }
    return disable
  }

  const handleConfirm = async () => {
    await cadaverService.cadastrarFenomenoCadaverico(
      idExame,
      idCadaver,
      formAddFenomeno.formState.values,
      setProcessando
    )
    cadaverService.getFenomenosCadavericosCadaver(
      idExame,
      idCadaver,
      setFenomenosCadavericos,
      setProcessando
    )
    setOpen(false)
    formAddFenomeno.resetFormValues()
  }

  const handleCloseForm = () => {
    setOpen(false)
    formAddFenomeno.resetFormValues()
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleCloseForm}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justify="space-between"
          >
            <Typography variant="h6">
              <b>DADOS DO FENÔMENO CADAVÉRICO</b>
            </Typography>
            <Grid item md={12} sm={12} xs={12}>
              <Divider className={classes.dividerTitle} />
            </Grid>
            <Grid item md={12} sm={12} xs={12} className={classes.corpoFormulario}>
              <SelectComposto
                formState={formAddFenomeno.formState}
                nomePropriedadeSelect="tipo"
                nomePropriedadeInputText="tipoTextoLivre"
                md={12}
                sm={12}
                options={options.tiposFenomenosCadavericos || []}
                handleChangeOption={formAddFenomeno.handleChangeNewValueByNameProperty}
                handleChangeInputText={formAddFenomeno.handleChange}
                labelSelect="Tipo do fenômeno cadáverico"
                shrink
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12} className={classes.CampoForm}>
              <TextField
                fullWidth
                label="Observações"
                name="observacoes"
                variant="outlined"
                onChange={formAddFenomeno.handleChange}
                value={formAddFenomeno.formState.values.observacoes}
                InputLabelProps={{
                  shrink: true,
                  className: classes.labelInput,
                }}
              />
            </Grid>

            <Grid item md={12} sm={12} xs={12} className={classes.dividerBotton}>
              <Divider />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Grid container justify="space-between" className={classes.botoesFormulario}>
                <Button onClick={handleCloseForm} className={classes.backButton}>
                  Cancelar
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirm}
                  disabled={formError() || processando}
                >
                  Adicionar fenômeno
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Fade>
    </Modal>
  )
}
